import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import TasksView from "@/components/crm/TasksView";
import LeadDrawer from "@/components/crm/LeadDrawer";
import { useLiveRev } from "@/lib/live";
import { cached, remember } from "@/lib/cache";

export default function TasksPage() {
  const [params, setParams] = useSearchParams();
  const [cfg, setCfg] = useState(cached("crm_cfg") || null);
  const [users, setUsers] = useState(cached("crm_users") || []);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    api.get("/crm/config").then((r) => setCfg(remember("crm_cfg", r.data)));
    api.get("/crm/users").then((r) => setUsers(remember("crm_users", r.data.rows)));
  }, []);
  const changed = useCallback(() => setTick((t) => t + 1), []);
  useLiveRev(changed);
  const leadId = params.get("lead");
  return (
    <div data-testid="tasks-page">
      <div className="flex items-center gap-4 px-4 md:px-6 py-3 border-b border-[var(--border)]">
        <h1 className="text-xl font-semibold tracking-tight" data-testid="page-title">Tasks</h1>
        <span className="text-sm text-[var(--text-dim)]">Every follow-up from the SOPs, soonest first</span>
      </div>
      <div className="px-4 md:px-6 py-4">
        <TasksView cadence={cfg?.cadence} onOpen={(id) => setParams({ lead: id })} refreshKey={tick} onChanged={changed} />
      </div>
      {cfg && <LeadDrawer leadId={leadId} cfg={cfg} users={users} onClose={() => setParams({})} onChanged={changed} />}
    </div>
  );
}
